/* eslint-disable no-console */
import React from 'react'
import { Button, Typography, useNotification } from '@fortressiq/fiq-ds'
import axios from 'axios'
import api from 'lib/Api'

const LinkVerification = ({
  matchedId,
  rowData,
  verificationLinksData,
  setVerificationLink,
  handleReFetch,
  whitelistStatus,
  setSortBy,
}) => {
  const { addNotification } = useNotification()

  const getVerifyLink = async rowVales => {
    try {
      const { data } = await api.post(`/ip_addresses/${rowVales.id}/verification_link`)
      if (data.url) {
        setVerificationLink([{ id: rowVales.id, url: data.url }, ...verificationLinksData])
      }
    } catch (error) {
      addNotification({
        description: error.message || 'An error occurred',
        message: 'Error',
        type: 'error',
      })
    }
  }

  const handleVerification = async () => {
    try {
      const { data } = await axios.get(matchedId.url)
      if (data.msg !== 'Success') {
        addNotification({
          description: data.msg,
          message: 'Error',
          type: 'error',
        })
      } else {
        const newVerificationArray = verificationLinksData.filter(val => val.id !== matchedId.id)
        setVerificationLink(newVerificationArray)
        setSortBy('active')
        handleReFetch()
      }
    } catch (error) {
      addNotification({
        description: error.message || 'An error occurred',
        message: 'Error',
        type: 'error',
      })
    }
  }

  if (rowData.verified) {
    return 'Verified'
  }

  if (rowData.locked && !rowData.verified) {
    return 'Not Verified'
  }

  return (
    <React.Fragment>
      <Button
        disabled={!whitelistStatus}
        className='getVerifyLinkButton'
        size='small'
        type={matchedId ? '' : 'default'}
        onClick={() => (matchedId ? handleVerification() : getVerifyLink(rowData))}
      >
        {matchedId ? 'Click here to verify' : 'Get verify link'}
      </Button>
      {matchedId && <Typography.Text copyable={true} textToCopy={matchedId.url} />}
    </React.Fragment>
  )
}

export default LinkVerification
